<template>
  <div class="container d-flex align-items-center" id="path">
    <div class="row">
      <div class="col-12">
        <div class="text-center service-text mb-5">
          <h5>Services</h5>
          <h3 class="fw-bold my-3">What I Am Great At</h3>
          <p>
            A young experienced developer, willing to make clean and neat websites,
            <br />
            dynamic web apps with database systems.
          </p>
        </div>
      </div>
      <div class="col-12 col-md-4 mt-3 mt-md-0">
        <div class="card blur shadow left-service">
          <div class="p-3">
            <img src="../assets/photo/services/prototype.jpg" class="card-img-top rounded service-card-img" />
          </div>
          <div class="card-body">
            <h5 class="card-title mb-3 text-center fw-bold">Prototype/ Web Design</h5>
            <p class="card-text">Making prototype, sketch and wireframe models for web designs using tools like adobe XD, Figma.</p>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 mt-3 mt-md-0">
        <div class="card blur shadow center-service">
          <div class="p-3">
            <img src="../assets/photo/services/frontend.jpg" class="card-img-top rounded service-card-img" />
          </div>
          <div class="card-body">
            <h5 class="card-title mb-3 text-center fw-bold">Frontend Development</h5>
            <p class="card-text">Making static website such as portfolio, personal and company profile websites, including some cool features with clean and attractive design.</p>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 mt-3 mt-md-0">
        <div class="card blur shadow right-service">
          <div class="p-3">
            <img src="../assets/photo/services/webdevelopment.jpg" class="card-img-top rounded service-card-img" />
          </div>
          <div class="card-body">
            <h5 class="card-title mb-3 text-center fw-bold">Prototype/ Web Design</h5>
            <p class="card-text">Making prototype, sketch and wireframe models for web designs using tools like adobe XD, Figma.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
